import BusinessLogicException from "exceptions/BusinessLogicException";
import type { CoreBankingEntity } from "types";
import type { ActionHookArg } from "../Props";
import useActionHandler from "./useActionHandler";

const defaultRequestHandler = async <T extends CoreBankingEntity>(row: T) => new Response();

export default function useStillPendingSettlementCSV<T extends CoreBankingEntity>({
    row,
    handler = defaultRequestHandler
}: ActionHookArg<
    T,
    typeof defaultRequestHandler
>) {
    const actionHandler = useActionHandler(row);

    return actionHandler(async () => {
        if (!row.coreId) {
            throw new BusinessLogicException("Invalid ID!", {});
        }

        const response = await handler(row);

        if (!response.ok) {
            throw new BusinessLogicException("Something went wrong while generating .CSV file", { response });
        }
    });
};
